module.exports = __webpack_public_path__ + "static/media/SplunkCloudAdmin.a2bde848.png";